module.exports = __webpack_public_path__ + "img/1.2646691c.webp";